import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "3.43 3.57 17.14 16.36"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "m12 17.275-4.15 2.5a.9.9 0 0 1-.575.15.97.97 0 0 1-.525-.2 1.2 1.2 0 0 1-.35-.438.87.87 0 0 1-.05-.587l1.1-4.725L3.775 10.8A.96.96 0 0 1 3.5 9.725q.1-.275.3-.45.2-.176.55-.225l4.85-.425 1.875-4.45q.125-.3.388-.45.262-.15.537-.15t.537.15.388.45l1.875 4.45 4.85.425q.35.05.55.225t.3.45a.96.96 0 0 1-.275 1.075l-3.675 3.175 1.1 4.725a.87.87 0 0 1-.05.588q-.125.261-.35.437a.97.97 0 0 1-.525.2.9.9 0 0 1-.575-.15z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }